// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3rPbzsqfEXPe","nav_prev":"_21kvU9lJQNMF","nav_next":"_2n3A3RL0OHGA"};